import SUPPORTED_LANGUAGES from '../../../languages'
import moment from 'moment'

let strings = {}

const DEFAULT_LOCALE = 'en'

const CURRENT_SCRIPT_SRC = document.currentScript.src

const getParentLocale = locale => {
  const [parent, child] = locale.split('-', 2)

  return child && parent
}

const getTranslationFile = async (locale, basePath) => {
  const resp = await fetch(new URL(`${locale}.json`, basePath))
  const json = await resp.json()

  return json
}

export const initTranslate = async (locale, basePath = CURRENT_SCRIPT_SRC) => {
  moment.locale(locale)

  strings = await getTranslationFile(DEFAULT_LOCALE, basePath)

  if (locale === DEFAULT_LOCALE) {
    return
  }

  if (SUPPORTED_LANGUAGES.includes(locale)) {
    strings = Object.assign(
      strings,
      await getTranslationFile(locale, basePath)
    )
  } else {
    const parentLocale = getParentLocale(locale)

    if (parentLocale !== DEFAULT_LOCALE && SUPPORTED_LANGUAGES.includes(parentLocale)) {
      strings = Object.assign(
        strings,
        await getTranslationFile(parentLocale, basePath)
      )
    }
  }
}

export const translate = (key, options) => {
  if (!key) {
    return ''
  }

  const data = strings[key]

  if (!data) {
    return `[[${key}]]`
  }

  const substitute = (match, s) => (
    (options && options[s]) || `{${s}}`
  )

  const result = data.replace(/\{(\w+)\}/g, substitute)

  return result
}

export default translate
